import { Box, CircularProgress } from "@mui/material";

const CenteredLoadingOverlay = ({loading}: {loading: boolean}) => {
    return (
        <Box sx={{ display: 'flex', position: 'absolute', left: 0, top: 0, justifyContent: 'center', alignItems: 'center', 
        height: '100%', width: '100%', zIndex: 100, backgroundColor: 'transparent', 
        visibility: loading ? 'visible' : 'hidden'}}>
            <CircularProgress />
        </Box>
    );
}

export default CenteredLoadingOverlay;